export default __webpack_public_path__ + "3981c9f299ae29c93dc0cc9f7f7df99f.svg";